/*  ========================================================================
    # Hooks - Use Contact Persons API
    ========================================================================  */

import { useEffect, useState } from 'react';

const useContactPersonsApi = params => {
  const [loading, setLoading] = useState(true);
  const [contactPersons, setContactPersons] = useState([]);
  const paramsString = new URLSearchParams();

  const getData = async () => {
    setLoading(true);

    // If showAllContactPersons is false and selectedContactPersons exist, use specific IDs
    if (params.showAllContactPersons === false && params.selectedContactPersons && params.selectedContactPersons.length > 0) {
      // Extract IDs from selectedContactPersons and pass them to the API
      const selectedIds = params.selectedContactPersons.map(person => person.ID || person.id || person).join(',');
      paramsString.append('ids', selectedIds);
    } else {
      // Use filter parameters for all contact persons
      for (const [key, value] of Object.entries(params)) {
        if (key !== 'showAllContactPersons' && key !== 'selectedContactPersons' && value) {
          paramsString.append(key, value.toString());
        }
      }
    }

    try {
      const response = await fetch(`/wp-json/ddp/v1/contactpersons?${paramsString.toString()}`);

      if (response.status !== 200) throw new Error(await response.text());

      const data = await response.json();

      // Sort contact persons alphabetically by surname.
      const sortedData = data.sort((a, b) => {
        const surnameA = a.acf.surname || '';
        const surnameB = b.acf.surname || '';
        return surnameA.localeCompare(surnameB);
      });

      setLoading(false);
      setContactPersons(sortedData);
    } catch (error) {
      setLoading(false);
      console.log(error); // eslint-disable-line no-console
    }
  };

  useEffect(() => {
    getData();
  }, [params.showAllContactPersons, params.selectedContactPersons, params.location, params.industry, params.focus, params.subfocus]);

  return { loading, contactPersons };
};

export default useContactPersonsApi;
